/**
 * Ảnh đại diện trong bong bóng chat.
 *
 * CỐ Ý không dùng useStaffAvatarMap(): hook đó gọi useStaff() và cần phiên
 * nhân viên, mà bong bóng chat còn chạy ở cổng khách /booking/me — nơi phiên
 * đó không tồn tại. Chỉ mượn ba hàm THUẦN bên dưới.
 */
import { avatarSrcFor, avatarTint, staffInitials } from "@/lib/staff-avatar";
import { cn } from "@/lib/utils";

type Props = {
  name: string;
  /**
   * Giá trị thô của staff.avatar_url (khoá lưu trữ hoặc URL Casdoor tuyệt đối)
   * — KHÔNG phải địa chỉ cuối. avatarSrcFor lo phần ghép biến thể; gắn thẳng
   * khoá lưu trữ vào <img src> là ảnh 404.
   */
  src?: string | null | undefined;
  sizePx?: number | undefined;
  className?: string | undefined;
};

export function ChatAvatar({ name, src, sizePx = 32, className }: Props) {
  const label = name.trim() || "Gạo Nâu";
  const url = avatarSrcFor(src, sizePx);
  const style = { width: sizePx, height: sizePx };

  if (url) {
    return (
      <img
        src={url}
        alt={label}
        loading="lazy"
        style={style}
        className={cn("shrink-0 rounded-full object-cover", className)}
      />
    );
  }
  return (
    <span
      aria-hidden="true"
      style={{ ...style, background: avatarTint(label), fontSize: Math.max(9, sizePx * 0.38) }}
      // text-black/70 chứ không phải text-white: avatarTint trả pastel sáng
      // (lightness 80%), chữ trắng trên nền đó gần như không đọc được. Giữ
      // đúng cách StaffAvatar toàn app đang làm.
      className={cn(
        "flex shrink-0 items-center justify-center rounded-full font-semibold text-black/70",
        className,
      )}
    >
      {staffInitials(label)}
    </span>
  );
}
